module.exports = __webpack_public_path__ + "img/event-is-live.4a7c35ca.svg";